// Custom HECHTER PARIS: Fitguide-Hinweis
// Legt ein Kunde dasselbe Produkt in einer zweiten Groesse in den Warenkorb,
// erscheint vorher einmal pro Besuch ein Hinweis auf den Fitguide.
// Greift auf der Produktseite und bei der Quick-Buy-Groessenleiste auf Kollektionsseiten.
// Der eigentliche Add-to-Cart bleibt beim bestehenden product-form-component.
if (!window.__hechterFitguideHintInit) {
  window.__hechterFitguideHintInit = true;

  const SESSION_KEY = 'hechterFitguideHintShown';
  const SKIP_FLAG = 'hechterFitguideHintSkip';
  const SIZE_OPTION = /^(gr(ö|oe)(ß|ss)e|size|taille)$/i;
  const COLOR_OPTION = /^(farbe|color|colour|couleur)$/i;
  const FALLBACK_GUIDE = 'pages/fit-guide';

  const alreadyShown = () => {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const markShown = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      /* Storage gesperrt: Hinweis kann dann erneut erscheinen */
    }
  };

  const rootUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  /** Groesse eines Cart-Items aus options_with_values lesen */
  const itemOption = (item, pattern) => {
    const opts = item.options_with_values || [];
    const hit = opts.find((o) => pattern.test(o.name));
    return hit ? hit.value : opts.length === 1 ? opts[0].value : '';
  };

  /** Produkt-URL der Kachel bzw. Produktseite finden */
  const findProductPath = async (component, variantId) => {
    let url = component.dataset.productUrl;
    if (!url) {
      const card = component.closest('product-card, .product-card, li, article');
      const link = card?.querySelector('a[href*="/products/"]');
      url = link?.getAttribute('href') || '';
    }
    if (!url) {
      const res = await fetch(`${rootUrl()}variants/${variantId}`, { redirect: 'follow' });
      url = res.url;
    }
    const parsed = new URL(url, window.location.origin);
    return parsed.pathname.replace(/\/$/, '');
  };

  /** Fitguide-Link: auf der Produktseite direkt, sonst aus der Produktsektion laden */
  const findGuideUrl = async (productPath) => {
    const onPage = document.querySelector('.hechter-fitguide-link a');
    if (onPage && window.location.pathname.replace(/\/$/, '') === productPath) {
      return onPage.getAttribute('href');
    }
    try {
      const res = await fetch(`${productPath}?section_id=main`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const link = doc.querySelector('.hechter-fitguide-link a');
      if (link) return link.getAttribute('href');
    } catch (e) {
      /* Fallback unten */
    }
    return rootUrl() + FALLBACK_GUIDE;
  };

  const resubmit = (form) => {
    form.dataset[SKIP_FLAG] = '1';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  };

  const showHint = ({ form, existingSize, newSize, item, guideUrl }) => {
    const dialog = document.getElementById('HechterFitguideHint');
    if (!dialog || typeof dialog.showModal !== 'function') {
      resubmit(form);
      return;
    }
    const fill = (text, size) => (text || '').split('[size]').join(size);
    const t = dialog.dataset;

    dialog.querySelector('[data-hint-text]').innerHTML = fill(t.text, existingSize);
    dialog.querySelector('[data-hint-title]').textContent = item.product_title || '';
    const color = itemOption(item, COLOR_OPTION);
    const meta = fill(t.inCart, existingSize);
    dialog.querySelector('[data-hint-meta]').textContent = color && color !== existingSize ? `${color} · ${meta}` : meta;

    const thumb = dialog.querySelector('[data-hint-thumb]');
    if (item.image) {
      const src = new URL(item.image, window.location.origin);
      src.searchParams.set('width', '160');
      thumb.src = src.toString();
      thumb.alt = item.product_title || '';
      thumb.hidden = false;
    } else {
      thumb.hidden = true;
    }

    dialog.querySelector('[data-hint-guide]').setAttribute('href', guideUrl);
    const anyway = dialog.querySelector('[data-hint-anyway]');
    anyway.textContent = newSize ? fill(t.addAnyway, newSize) : t.addAnywayPlain;

    const close = () => dialog.close();
    anyway.onclick = () => {
      close();
      resubmit(form);
    };
    dialog.querySelectorAll('[data-hint-close]').forEach((btn) => (btn.onclick = close));
    dialog.onclick = (event) => {
      if (event.target === dialog) close();
    };

    markShown();
    dialog.showModal();
  };

  const check = async (form, component) => {
    const variantId = Number(new FormData(form).get('id'));
    const productId = Number(component.dataset.productId);
    if (!variantId || !productId) return resubmit(form);

    const cart = await fetch(`${rootUrl()}cart.js`).then((r) => r.json());
    const item = (cart.items || []).find((i) => i.product_id === productId && i.variant_id !== variantId);
    if (!item) return resubmit(form);

    const existingSize = itemOption(item, SIZE_OPTION);
    const productPath = await findProductPath(component, variantId);

    let newSize = '';
    try {
      const product = await fetch(`${productPath}.js`).then((r) => r.json());
      const variant = product.variants.find((v) => v.id === variantId);
      const names = (product.options || []).map((o) => (typeof o === 'string' ? o : o.name));
      let index = names.findIndex((n) => SIZE_OPTION.test(n));
      if (index < 0 && names.length === 1) index = 0;
      if (variant && index >= 0) newSize = variant.options[index];
    } catch (e) {
      /* Button zeigt dann den Text ohne Groesse */
    }

    // Gleiche Groesse (z. B. anderes Merkmal) ist kein Fall fuer den Fitguide
    if (existingSize && newSize && existingSize === newSize) return resubmit(form);

    const guideUrl = await findGuideUrl(productPath);
    showHint({ form, existingSize, newSize, item, guideUrl });
  };

  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!(form.getAttribute('action') || '').includes('/cart/add')) return;
      const component = form.closest('product-form-component');
      if (!component) return;

      if (form.dataset[SKIP_FLAG]) {
        delete form.dataset[SKIP_FLAG];
        return;
      }
      if (alreadyShown()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      check(form, component).catch(() => resubmit(form));
    },
    true
  );
}
